import { useState } from 'react'

import style from '../../../styles/Weather/weather_weekly_conditions'
import Bottom from './Bottom'
import Top from './Top'

const WeekDay = ({ day }) => {
  const [isCollapsed, setIsCollapsed] = useState(false)

  const props = { day, isCollapsed }

  const clickHandler = () => {
    setIsCollapsed(!isCollapsed)
  }

  return (
    <div className='day' onClick={clickHandler}>
      <Top {...props} />
      <Bottom {...props} />
      <style jsx>{style}</style>
    </div>
  )
}

export default WeekDay
